import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import BookFlow from 'components/Flows/BookFlows/BookFlows';
import BookAnalysisDrawer from 'components/Analyses/BookAnalyses/Drawer/Drawer';

const BookFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <BookAnalysisDrawer />
      <BookFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <BookFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);